import { render } from "./P088.vue?vue&type=template&id=667710a9&scoped=true"
import script from "./P088.vue?vue&type=script&lang=js"
export * from "./P088.vue?vue&type=script&lang=js"

import "./P088.vue?vue&type=style&index=0&id=667710a9&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667710a9"]])

export default __exports__